import ProjectMenu from "../components/projects-menu/projects-menu.component";


const Projects = () => (
    <>
        <ProjectMenu />
    </>
)

export default Projects;